import type { INode } from '@/api/nodes/mutations/directory/create-directory-mutation'

/** Product edits expand folders; label edits still apply only to explicitly selected files. */
export function getDirectorySelectionScope(nodes: readonly (Pick<INode, 'type'> & { file?: object | null })[]) {
    const fileCount = nodes.filter((node) => node.type === 'FILE' && !!node.file).length
    const folderCount = nodes.filter((node) => node.type === 'DIRECTORY').length

    return {
        fileCount,
        folderCount,
        canEditLabels: fileCount > 0,
        canEditProducts: fileCount + folderCount > 0,
        ignoredLabelCount: nodes.length - fileCount,
        ignoredProductCount: nodes.length - fileCount - folderCount,
    }
}

/** Folder descendants are resolved on save, so explicit file matches cannot prove full membership. */
export function getConnectionSelectionDisplayState({
    hasPendingAdd,
    hasPendingRemove,
    matchingFileCount,
    selectedFileCount,
    includesFolders = false,
}: {
    hasPendingAdd: boolean
    hasPendingRemove: boolean
    matchingFileCount: number
    selectedFileCount: number
    includesFolders?: boolean
}) {
    if (hasPendingAdd) return 'pending-add' as const
    if (hasPendingRemove) return 'pending-remove' as const
    if (includesFolders) return 'partial' as const
    if (matchingFileCount >= selectedFileCount && selectedFileCount > 0) return 'selected' as const
    if (matchingFileCount > 0) return 'partial' as const
    return 'unselected' as const
}
